<template>
  <div class="formSectionCompound"/>
</template>

<script>
import InputField from './fields/InputField'
import SelectField from './fields/SelectField'
import * as countryCodes from '../../types/country-code'
import * as addressTypes from '../../types/address-type'
import { countryCode } from '../../validators'
import customFilters from '../../filters'

export default {
  name: 'BaseAddressSubForm',
  components: {
    InputField,
    SelectField
  },
  props: {
    address: {
      type: Object,
      required: true
    },
    addressType: {
      type: String,
      required: true
    },
    disableFields: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      countryCodeOptions: [
        { value: countryCodes.COUNTRY_CODE_NLD, text: this.$t('companyForm.nederland'), default: true },
        { value: countryCodes.COUNTRY_CODE_BEL, text: this.$t('companyForm.belgie') },
        { value: countryCodes.COUNTRY_CODE_DEU, text: this.$t('companyForm.duitsland') }
      ],
      addressTypes,
      filters: {
        capitalize: customFilters.capitalize,
        upperCase: customFilters.upperCase,
        digits: customFilters.digits
      },
      baseAddressValidationConfig: {
        countryCode: {
          countryCode
        }
      }
    }
  },
  methods: {
    touchValidation () {
      return this.$v.$touch()
    },
    isInvalid () {
      return this.$v.$invalid
    },
    setCompanyAddressProperty (property, value) {
      this.address[property] = value
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/forms/BaseAddressSubForm.vue